import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
    Autocomplete,
    Dialog,
    Grid,
    IconButton, TextField,
    Typography
} from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { fetchTrackedMissions } from '../../../Api/suiviMission/missions';
import SwitchMissionList from '../SwitchMissionsList';

const styles = {
    dialogPaper: {
        minHeight: '45vh',
        maxHeight: '45vh',
    },
};

function SwitchMissionModal({ handleClose, open }) {
    SwitchMissionModal.propTypes = {
        open: PropTypes.func,
        handleClose: PropTypes.func,
    };
    const [rows, setrows] = useState([]);
    const [missions, setmissions] = useState([]);
    const { i18n } = useTranslation();
    useEffect(() => {
        fetchTrackedMissions(setrows);
        fetchTrackedMissions(setmissions);
    }, []);
    return (
        <div>
            <Dialog
                fullWidth="true"
                maxWidth="md"
                maxHeight="md"
                open={open}
                onClose={handleClose}
                scroll="body"
            // classes={{ paper: classes.dialogPaper }}
            >
                <Grid
                    container
                    sx={{ padding: '30px' }}
                >
                    <Grid
                        container
                        justifyContent="end"
                        xs={12}
                    >
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        xs={12}
                    >
                        <div
                            style={{
                                padding: '4px',
                                backgroundColor: '#19223F',
                                borderRadius: '4px',
                                display: 'flex',
                                justifyContent: 'center',
                                width: 'fit-content',
                                marginRight: '10px',
                                marginBottom: '30px',
                            }}
                        >
                            <ChangeCircleIcon
                                fontSize="large"
                                sx={{ color: '#FFFFFF' }}
                            />
                        </div>
                        <Typography
                            fontSize={25}
                            style={{ fontWeight: 'bolder' }}
                        >
                            {i18n.t('Changer de mission')}
                        </Typography>
                        <div
                            style={{
                                padding: '4px',
                                backgroundColor: '#19223F',
                                borderRadius: '4px',
                                display: 'flex',
                                justifyContent: 'center',
                                width: 'fit-content',
                                marginRight: '10px',
                                marginBottom: '30px',
                            }}
                        >
                            <ChangeCircleIcon
                                fontSize="large"
                                sx={{ color: '#FFFFFF' }}
                            />
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        <Autocomplete
                            onChange={(vent, value, reason) => {
                                if (reason === 'clear') {
                                    setmissions(rows);
                                } else {
                                    const m = rows.filter((row) => row._id === value._id);
                                    setmissions(m);
                                }
                            }}
                            disablePortal
                            id="missions"
                            getOptionLabel={(option) => {
                                return option?.titre + '    ' + 'Ref';
                            }}
                            options={rows}
                            size="small"
                            sx={{ width: 200, marginRight: '10px' }}
                            renderOption={(props, option) => {
                                return (
                                    <li
                                        {...props}
                                        key={option._id}
                                    >
                                        {option?.titre + '    ' + 'Ref'}
                                    </li>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={i18n.t('Missions')}
                                />
                            )}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        <SwitchMissionList
                            rows={missions}
                            handleClose={handleClose}
                        />
                    </Grid>
                </Grid>
            </Dialog>
        </div>
    );
}

export default withStyles(styles)(SwitchMissionModal);
